import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "announcement-settings",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "admin-announcements-manager" */ "Administrator/routes/Settings/routes/AnnouncementsManager/routes/AnnouncementSettings/components"
      ),
    ])
      .then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
      .catch(err => {
        return err;
      })
  ),
});
